import React, { createContext, useEffect, useReducer } from "react";
import productReducer, {
  actionTypes,
  initialState,
} from "./addOrderReturnReducer";
import { readDraft, writeDraft } from "./draft";

export const AddOrderReturnContext = createContext();

/**
 * @param {string} [props.draftKey] sessionStorage-ийн key. Дамжуулбал сонгосон
 * захиалга, бараа refresh хийхэд сэргэнэ. Дамжуулаагүй бол хадгалахгүй.
 */
export const AddOrderReturnProvider = ({ draftKey, children }) => {
  // Хуудас refresh хийхэд бөглөсөн мэдээлэл сэргэхийн тулд эхлэхдээ л уншина
  const [state, dispatch] = useReducer(productReducer, initialState, (initial) => ({
    ...initial,
    ...readDraft(draftKey),
  }));

  // Төлөв өөрчлөгдөх бүрд draft-ыг шинэчилнэ
  useEffect(() => {
    writeDraft(draftKey, state);
  }, [draftKey, state]);

  const setReference = (reference) => {
    dispatch({
      type: actionTypes.setReference,
      payload: reference,
    });
  };

  const selectOrder = (order) => {
    dispatch({
      type: actionTypes.selectOrder,
      payload: order,
    });
  };

  // const setDropOffAddress = (address = []) => {
  //   dispatch({
  //     type: actionTypes.setDropOffAddress,
  //     payload: address,
  //   });
  // };

  const addProduct = (products) => {
    dispatch({
      type: actionTypes.addProduct,
      payload: products,
    });
  };

  const removeProduct = (id) => {
    dispatch({
      type: actionTypes.removeProduct,
      payload: id,
    });
  };

  const changeTotalUnit = (id, totalUnit) => {
    dispatch({
      type: actionTypes.changeTotalUnit,
      payload: {
        id,
        totalUnit,
      },
    });
  };

  const setFormDataStep1 = (data) =>
    dispatch({
      type: actionTypes.setFormDataStep1,
      payload: data,
    });

  const setFormDataStep2 = (data) =>
    dispatch({
      type: actionTypes.setFormDataStep2,
      payload: data,
    });

  const value = {
    ...state,
    draftKey,
    setReference,
    selectOrder,
    // setDropOffAddress,
    addProduct,
    removeProduct,
    changeTotalUnit,
    setFormDataStep1,
    setFormDataStep2,
  };
  return (
    <AddOrderReturnContext.Provider value={value}>{children}</AddOrderReturnContext.Provider>
  );
};
